var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-app", [
    _c("div", { staticClass: "app-wrapper" }, [
      _c("main", { staticClass: "main" }, [
        _c("div", { staticClass: "modal" }, [
          _c(
            "div",
            { staticClass: "modal__content" },
            [
              !_vm.result
                ? [
                    _c("img", {
                      staticClass: "modal__icon",
                      attrs: { src: require("../images/sms-press.svg") },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "(###) ###-##-##",
                          expression: "'(###) ###-##-##'",
                        },
                      ],
                      staticClass: "modal__input",
                      attrs: {
                        placeholder: "Введите номер телефона",
                        outlined: "",
                      },
                      model: {
                        value: _vm.phone,
                        callback: function ($$v) {
                          _vm.phone = $$v
                        },
                        expression: "phone",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "smart-captcha",
                      attrs: {
                        id: "captcha-container",
                        "data-sitekey":
                          "ysc1_sI5gz2hJVsIJyFOteHZtwKtPsLcMjf4hddOYUTjy52373d6f",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "_orange",
                        on: { click: _vm.handleAcceptClick },
                      },
                      [_vm._v("Получить смс со ссылкой")]
                    ),
                  ]
                : !(_vm.result in _vm.messageMap)
                ? [
                    _c("img", {
                      staticClass: "modal__icon",
                      attrs: { src: require("../images/sms-error.svg") },
                    }),
                    _vm._v(" "),
                    _c("p", { domProps: { innerHTML: _vm._s(_vm.result) } }),
                  ]
                : [
                    _c("img", {
                      staticClass: "modal__icon",
                      attrs: {
                        src: require(`../images/sms-${
                          _vm.messageMap[_vm.result].icon
                        }.svg`),
                      },
                    }),
                    _vm._v(" "),
                    _c("p", {
                      class: {
                        _clickable: _vm.messageMap[_vm.result].can_reload,
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.messageMap[_vm.result].text),
                      },
                      on: {
                        click: function ($event) {
                          _vm.messageMap[_vm.result].can_reload
                            ? _vm.reloadPage()
                            : ""
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }